module.exports = __webpack_public_path__ + "static/img/7079_phase_function_Paper_Points.fbf3ccf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7079_phase_function_Paper_Points.png
// module id = QPH7
// module chunks = 0